type Props = {
    children?: React.ReactNode;
};

const AppParamProvider: React.FC<Props> = ({ children }) => {
    return <>{children}</>;
};

export default AppParamProvider;